import React from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import {
  FaSortAmountUpAlt,
  FaSortAmountDownAlt,
  FaEyeSlash,
} from "react-icons/fa";
import { NavDropdown } from "react-bootstrap";
import "./dropdown.css";
import { handleFieldHide, handleFieldSort } from "../../utils/helpers";

/**
 * NumberDropdownComponent (Numeric Field Dropdown)
 * 
 * Dropdown menu for numeric datatable columns providing sort options:
 * - Sort smaller to larger (ascending)
 * - Sort larger to smaller (descending)
 * - Hide column from view
 * 
 * @param {Object} props - Component props
 * @param {Object} props.field - Field object with actualName and type
 * @returns {JSX.Element} Column header dropdown for numeric fields
 */

const NumberDropdownComponent = ({ props, field }) => {
  return (
    <>
      <NavDropdown
        align="end"
        className="sort-navbardropdown"
        title={<IoMdArrowDropdown className="sort-navbaricon" />}
        id="basic-nav-dropdown"
      >
        <NavDropdown.Item
          onClick={() =>
            handleFieldSort(props, field, " Sort smaller to larger")
          }
          className="sort-navbardropdownitem"
          id="sort-navbaractive"
        >
          <FaSortAmountDownAlt /> Sort smaller to larger
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={() =>
            handleFieldSort(props, field, " Sort larger to smaller")
          }
          className="sort-navbardropdownitem"
          id="sort-navbaractive"
        >
          <FaSortAmountUpAlt /> Sort larger to smaller
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={() => handleFieldHide(props, field)}
          className="sort-navbardropdownitem"
          id="sort-navbaractive"
        >
          <FaEyeSlash /> Hide Field
        </NavDropdown.Item>
      </NavDropdown>
    </>
  );
};

export default NumberDropdownComponent;
